import { AtomIcon } from "lucide-react";

export const Icon = (props: React.ComponentProps<typeof AtomIcon>) => {
  return <AtomIcon {...props} />;
};
